import { atom, useAtom } from "jotai";
import { ModalSize } from "rizzui";

type ModalTypes = {
  view: React.ReactNode;
  isOpen: boolean;
  customSize?: string;
  size?: ModalSize;
};

const modalAtom = atom<ModalTypes>({
  isOpen: false,
  view: null,
  customSize: "320px",
  size: "sm",
});

export function useModal() {
  const [state, setState] = useAtom(modalAtom);

  const openModal = ({
    view,
    customSize,
    size,
  }: {
    view: React.ReactNode;
    customSize?: string;
    size?: ModalSize;
  }) => {
    setState({
      ...state,
      isOpen: true,
      view,
      customSize,
      size,
    });
  };

  const closeModal = () => {
    setState((prev) => {
      if (!prev.isOpen) return prev; // prevent unnecessary update
      return {
        ...prev,
        isOpen: false,
      };
    });
  };

  return {
    ...state,
    openModal,
    closeModal,
  };
}
